import React from 'react'
import { Button } from '@fluentui/react-components'
import { ModalActions } from '../../common/modal/Modal'
import { Text } from '../../common/text/Text'
import { t } from '../../../i18n/i18n'
import { DraggableModal } from '../../common/modal/DraggableModal'

type ModalResetAnswerProps = {
   open: boolean
   close: () => void
   onConfirm: () => Promise<void>
   isSubmitting: boolean
}
export const ModalResetAnswer = ({ open, close, onConfirm, isSubmitting }: ModalResetAnswerProps) => {
   return (
      <DraggableModal title={t('ResetAnswer')} open={open} onClose={close} noDivider>
         <Text>{t('ResetAnswerConfirmationMessage')}</Text>
         <ModalActions>
            <Button onClick={close} disabled={isSubmitting}>
               {t('Cancel')}
            </Button>
            <Button appearance="primary" onClick={onConfirm} disabled={isSubmitting}>
               {t('ResetAnswer')}
            </Button>
         </ModalActions>
      </DraggableModal>
   )
}
